var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 1,
    y: 1,
    width: 153,
    height: 153,
    rx: 21,
    fill: "#FEE2E2",
    stroke: "#EF4444",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.6267 125.125C103.761 125.125 125.125 103.761 125.125 77.6267C125.125 51.4928 103.761 30.125 77.6267 30.125C51.4928 30.125 30.125 51.4928 30.125 77.6267C30.125 103.761 51.4928 125.125 77.6267 125.125ZM77.6267 108.351C60.5622 108.351 46.9126 94.6912 46.9126 77.6267C46.9126 72.1705 48.3214 67.072 50.7776 62.6488L92.6181 104.476C88.1907 106.937 83.0869 108.351 77.6258 108.351L77.6267 108.351ZM104.476 92.619L62.6488 50.7784C67.0719 48.3223 72.1707 46.9134 77.6267 46.9134C94.6912 46.9134 108.351 60.563 108.351 77.6275C108.351 83.0884 106.938 88.1924 104.476 92.6198L104.476 92.619Z",
    fill: "#EF4444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoConvert);
export default __webpack_public_path__ + "static/media/noConvert.ce72881fefcab25953d32b181337488d.svg";
export { ForwardRef as ReactComponent };